export const NODE_ENV : 'Production' | 'Development' = 'Production'
export const API_KEY = 'f935758e-46c0-463d-9884-31913457138c'
export const API_URL = 'https://smart-agent.co.il'